export const FieldNames = {
  nameOrEmail: "nameOrEmail",
  betweenDates: "betweenDates",
  managerId: "managerId",
  skills: "skills",
  otherSkills: "otherSkills",
  rating: "rating",
  competences: "competences",
  addNote: "addNote",
  personnalCharacteristics: "personnalCharacteristics",
  availability: "availability",
  isNegotiable: "isNegotiable",
  exitReason: "exitReason",
  otherProposals: "otherProposals",
  expectedSalary: "expectedSalary",
  notDifinedSalary: "notDifinedSalary",
  desiredContractTypeId: "desiredContractTypeId",
  salaryInformation: "salaryInformation",
  managerInterestId: "managerInterestId",
  CurrentSalary: "CurrentSalary",
  currentContractTypeId: "currentContractTypeId",
  professionalExperienceYearsId: "professionalExperienceYearsId",
  mainActivities: "mainActivities",
  personalProfile: "personalProfile",
  comments: "comments",
  zoneId: "zoneId",
  mobility: "mobility",
  remoteWorkId: "remoteWorkId",
  birthDate: "birthDate",
  maritalStatusId: "maritalStatusId",
  numberOfDependantId: "numberOfDependantId",
  nationalityId: "nationalityId",
  needDocumentation: "needDocumentation",
  mobileNumber: "mobileNumber",
  linkedIn: "linkedIn",
  gitHub: "gitHub",
  courseId: "courseId",
  institutionId: "institutionId",
  coursebyDate: "coursebyDate",
  courseOnGoing: "onGoing",
  finalClassification: "finalClassification",
  notes: "notes",
  languageId: "languageId",
  recommended: "recommended",
  inactiveManagerId: "inactiveManagerId",
  languageLevelId: "languageLevelId",
  seniorityLevelsId: "seniorityLevelsId",
  currentLocation:"currentLocation",
  businessArea: "businessArea",
  techArea: "techArea",
  techRole: "techRole",
  candidateInterestBusinessArea: "candidateInterestBusinessArea",
  candidateInterestTechArea: "candidateInterestTechArea",
  candidateInterestTechRole: "candidateInterestTechRole",
  jobRoleId: "jobRoleId",
  tags: "tags",
};
